import axios, { AxiosError } from 'axios';

const instance = axios.create();

export function isAxiosError(error: unknown): error is AxiosError {
  return error instanceof Error && (error as any).isAxiosError;
}

export default instance;
